import * as ssr from '../../ssr';
function getSSRDoneTimeValue(config) {
  var _config$ssr, _config$ssr2;
  return config !== null && config !== void 0 && (_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getSSRDoneTime ? config === null || config === void 0 ? void 0 : (_config$ssr2 = config.ssr) === null || _config$ssr2 === void 0 ? void 0 : _config$ssr2.getSSRDoneTime() : ssr.getSSRDoneTime();
}
export default getSSRDoneTimeValue;